module.exports = __webpack_public_path__ + "img/id-gif.1f525aed.gif";